import { render, staticRenderFns } from "./ActorMessageComplete.vue?vue&type=template&id=1807ecd2"
import script from "./ActorMessageComplete.vue?vue&type=script&lang=js"
export * from "./ActorMessageComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports